<template>
  <div>
    <b-navbar toggleable="md" type="light">
      <b-container>
        <a
          v-if="showMenu"
          href=""
          @click.prevent="openDashboardSidebar"
          class="dashboard-toggle mr-3"
        >
          <font-awesome-icon icon="bars"></font-awesome-icon>
        </a>
        <b-navbar-brand
          href="#"
          class="logo"
          :to="{
            path: '/student/dashboard',
            query: { role: getUserRole }
          }"
          v-if="isAuthenticated && getUserRole === 'student'"
        >
          <strong>Edfore</strong>
        </b-navbar-brand>
        <b-navbar-brand
          href="#"
          class="logo"
          :to="{
            path: '/admin'
          }"
          v-if="isAuthenticated && getUserRole === 'teacher'"
        >
          <strong>Edfore</strong>
        </b-navbar-brand>
        <b-navbar-brand class="logo" href="#" to="/" v-if="!isAuthenticated"
          ><strong>Edfore</strong></b-navbar-brand
        >

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item-dropdown class="ourcourses-menu" @hide="closeRightDrop">
              <template slot="button-content">
                <font-awesome-icon icon="layer-group" size="xs" />
                <span>Our Courses</span>
              </template>
              <div class="dropdown-left-wrapper">
                <b-dropdown-item
                  v-for="category in getCategoryData"
                  :key="category.name"
                  id="dropdown_main"
                  href="#"
                >
                  <b-link
                    @mouseover="togglesub($event, category)"
                    @click="goToCourses(category)"
                    ><span>{{ category.name }}</span>
                    <font-awesome-icon icon="chevron-right"></font-awesome-icon>
                  </b-link>
                </b-dropdown-item>
              </div>
              <div class="dropdow-right-wrapper">
                <div class="dropdown-right-card">
                  <b-dropdown-item
                    v-for="category in categories.sub_category"
                    :key="category.name"
                    href="#"
                  >
                    <b-link
                      :to="{
                        path: '/courses',
                        query: {
                          categoryName: category.name,
                          categoryId: category.category_id
                        }
                      }"
                      @click="togglesub($event, category)"
                      >{{ category.name }}
                    </b-link>
                  </b-dropdown-item>
                </div>
              </div>
            </b-nav-item-dropdown>
            <b-nav-item class="header-search-bar">
              <search-bar :is-teacher="false"></search-bar>
              <!--              <search-courses :is-teacher="false"></search-courses>-->
              <!--              <button>-->
              <!--                <font-awesome-icon icon="search"></font-awesome-icon>-->
              <!--              </button>-->
            </b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto  align-items-center">
            <!-- <b-nav-item-dropdown right>
              Using 'button-content' slot
              <template slot="button-content"
                ><em>User</em></template
              >
              <b-dropdown-item href="#">Profile</b-dropdown-item>
              <b-dropdown-item href="#">Sign Out</b-dropdown-item>
            </b-nav-item-dropdown>-->
            <b-nav-item
              v-if="isAuthenticated"
              @click="toggleN"
              class="notification-toggler"
            >
              <font-awesome-icon icon="bell"></font-awesome-icon>
            </b-nav-item>
            <b-nav-item
              to="/help"
              right
              class="header-links header-help"
              v-if="$route.path !== '/help'"
            >
              <font-awesome-icon icon="info-circle" size="xs" />
              <span>Help</span>
            </b-nav-item>
            <b-nav-item class="header-links" v-if="!isAuthenticated">
              <span v-b-modal.modal-1>Login</span>
              <!-- modal -->
              <login-modal></login-modal>
              <forgot-modal></forgot-modal>
              <!-- modal -->
            </b-nav-item>
            <b-nav-item
              class="header-links"
              to="/register"
              v-if="!isAuthenticated && $route.path !== '/register'"
            >
              <span>Register</span>
            </b-nav-item>
            <!-- user dp-->
            <user-menu></user-menu>
            <!--user dp-->
            <!--<b-nav-item-->
            <!--class="header-links"-->
            <!--@click="logOut"-->
            <!--v-if="isAuthenticated"-->
            <!--&gt;-->
            <!--<font-awesome-icon icon="sign-out-alt" />-->
            <!--<span>Logout</span>-->
            <!--</b-nav-item>-->
            <b-nav-item
              class="header-user-actions"
              v-if="
                isAuthenticated &&
                  $route.path !== '/student/wishlist' &&
                  getUserRole === 'student'
              "
              @click="goToWishlist"
            >
              <font-awesome-icon icon="heart"></font-awesome-icon>
            </b-nav-item>
            <b-nav-item
              class="header-user-actions vr"
              to="/cart"
              v-if="$route.path !== '/cart' && getUserRole !== 'teacher'"
            >
              <font-awesome-icon icon="shopping-bag"></font-awesome-icon>
              <div class="count">
                {{ getCart.length }}
              </div>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
    <notification />
  </div>
</template>

<script>
import { authenticationApi } from "../../services/authenticationApi";
import LoginModal from "../modals/LoginModal";
import ForgotModal from "../modals/ForgotModal";
import { mapGetters } from "vuex";
import ClickOutside from "vue-click-outside";
import SearchCourses from "../Search/searchCourses";
import SearchBar from "../Search/SearchBar";
import Notification from "../Templates/Notification";
import { commonFunctions } from "../../Commonjs/commonFunctions";
import UserMenu from "./UserMenu";

export default {
  name: "header-nav",
  components: {
    UserMenu,
    Notification,
    SearchCourses,
    SearchBar,
    LoginModal,
    ForgotModal
  },
  props: {
    showMenu: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      categories: [],
      welcomeTitle: "My Courses"
    };
  },
  computed: {
    ...mapGetters("user", ["isAuthenticated", "getUserDetails", "getUserRole"]),
    ...mapGetters("category", ["getCategoryData"]),
    ...mapGetters("cart", ["getCart"])
  },
  methods: {
    goToCourses(category) {
      this.$router.push({
        path: "/courses",
        query: {
          categoryName: category.name,
          categoryId: category.category_id
        }
      });
    },
    redirectToAdmin() {
      // window.location.replace("https://edfore.techgentsia.com/app/#login");
      this.$router.push("/add_course");
    },
    goToWishlist() {
      this.$router.push({
        path: "/student/wishlist",
        query: { role: this.getUserRole }
      });
    },
    toggleN(e) {
      commonFunctions.toggleNotification(e);
    },
    openDashboardSidebar() {
      commonFunctions.toggleDashboardSideBar();
      // const dash = document.querySelector(".dashboard-sidemenu");
      // const backdrop = document.querySelector(".dashboard-sidemenu-backdrop");
      // console.log("ssss");
      // if (!dash.classList.contains("shown")) {
      //   dash.classList.add("shown");
      //   backdrop.classList.add("shown");
      //   document.body.classList.add("modal-open");
      // } else {
      //   return 0;
      // }
    },
    togglesub(e, category) {
      this.categories = category;
      const selector = document.querySelector(".dropdow-right-wrapper");
      // e.target.parentElement.classList.add("active");
      selector.classList.add("show");
      // if (selector.classList.contains("show")) {
      //   selector.classList.remove("show");
      // } else {
      //   selector.classList.add("show");
      // }
      document.querySelector(".dropdow-right-wrapper").style.height =
        document.querySelector(".dropdown-left-wrapper").offsetHeight + "px";
      document.querySelector(".dropdow-right-wrapper").style.width =
        document.querySelector(".dropdown-left-wrapper").offsetWidth + "px";
      document
        .querySelectorAll(".ourcourses-menu .dropdown-item a span")
        .forEach(data => {
          data.style.maxWidth =
            document.querySelectorAll(
              ".ourcourses-menu .dropdown-item a span"
            )[0].offsetWidth + "px";
        });
    },
    closeRightDrop() {
      const selector = document.querySelector(".dropdow-right-wrapper");
      selector.classList.remove("show");
    },
    logOut() {
      authenticationApi.logOut().then(res => {
        // if (this.$route.meta.requiredAuth) {
        //   if (this.$route.path === "/course_subscription") {
        //     this.$router.back();
        //   } else {
        //     this.$router.push("/");
        //   }
        // }
        this.$router.push("/");
      });
      this.$bvToast.toast("Logout successful", {
        title: "Logout",
        variant: "success",
        autoHideDelay: 500,
        appendToast: true
      });
    },

    closeUserMenu(e) {
      e.preventDefault();
      var parent = document.querySelector(".menu-container");
      if (parent.classList.contains("open")) {
        parent.classList.remove("open");
      }
    }
  }
};
</script>

<style></style>
